/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Image_Subtitles_TitleInputs */



/**
* | output |
* | --- |
* | "Image Subtitles" |
*
* @param {File_Export_Image_Subtitles_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_image_subtitles_title = /** @type {((inputs?: File_Export_Image_Subtitles_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Image_Subtitles_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titres en image")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildunterschriften")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitoli delle immagini")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Субтитры к изображениям")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtítulos de imágenes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("图片字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("画像の字幕")
	if (locale === "hi") return /** @type {LocalizedString} */ ("छवि उपशीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas de imagem")
	return /** @type {LocalizedString} */ ("Image Subtitles")
});